export const withBase = (path: string) => `${import.meta.env.VITE_BASE_URL}${path}`
